module.exports = __webpack_public_path__ + "img/marriott-red-sea.fa76bcfb.jpg";